import React, { useState } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import axios from 'axios';
// import { Link } from 'react-router-dom';

function Contact() {
  const [email,setemail]=useState('')
  const [subject,setsubject]=useState('')
  const [message,setmessage]=useState('')

  const handlesubmit=(e)=>{
    e.preventDefault()
    sendEmail(email,subject,message)
  }

  const sendEmail = async (email, subject, message) => {
    showLoader();
    try {
      const response = await axios.post('https://express-43ry.onrender.com/SendEmail', {
        email,
        subject,
        message
      });
  
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error sending email:', error);
      hideLoader();
    }
  };
  

  const showLoader = () => {
    const sendMessageButton = document.getElementById('send-message-button');
    const loadingButton = document.getElementById('loading-button');
  
    sendMessageButton.style.display = 'none';
    loadingButton.style.display = 'inline-flex';
  };
  
  // Function to hide loader and enable buttons
  const hideLoader = () => {
    const sendMessageButton = document.getElementById('send-message-button');
    const loadingButton = document.getElementById('loading-button');
  
    sendMessageButton.style.display = 'inline-block';
    loadingButton.style.display = 'none';
  };  

  return (
    <>
      <Header/>
    <section className="bg-white dark:bg-gray-900">
    <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
      <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">Contact Us</h2>
      <p className="mb-8 lg:mb-16 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">Vous avez un problème technique ? Vous souhaitez envoyer des commentaires sur une fonctionnalité bêta ? Besoin de détails sur notre plan Business ? Faites le nous savoir.</p>
      <form onSubmit={handlesubmit} className="space-y-8">
          <div>
              <div>
                <label  htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300" >Votre email</label>
                <input onChange={(e)=>{setemail(e.target.value)}} type="email" id="email" className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="name@domain.com" required />
              </div>
              <div>
                <label htmlFor="subject" className="block mb-2 mt-3 text-sm font-medium text-gray-900 dark:text-gray-300">Objet</label>
                <input onChange={(e)=>{setsubject(e.target.value)}}  type="text" id="subject" className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="Dites-nous comment nous pouvons vous aider" required />
              </div>
          </div>
          <div className="sm:col-span-2">
              <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Votre message</label>
              <textarea onChange={(e)=>{setmessage(e.target.value)}}  id="message" rows="6" className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Laissez un commentaire..." required></textarea>
          </div>
          <button id="send-message-button" type="submit" className="py-3 px-5 text-sm font-medium text-center text-white rounded-lg bg-[#0C64C3] sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Send message</button>

          <button  id="loading-button" style={{display:'none'}}disabled type="button" class="text-white bg-[#0C64C3] hover:bg-[#0C64C3] focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center">
          <svg aria-hidden="true" role="status" class="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
          </svg>
          Loading...
         </button>

         {/* <div style={{display:'none'}} className='' id='popUp-email'>
          <div className=''>
              <img src='' alt=''/>
          </div>
          <div className=''>
              <p>Votre email est envoyer</p>
          </div>
          <Link to="/Contact-Us"><button>Return</button></Link>

         </div> */}

         
      </form>
  </div>
</section>
      <Footer/>
    </>
  )
}

export default Contact